import { useCallback, useMemo, useState } from "react";
import { unitPreferencesService } from "../services/unitPreferencesService";
import { getDistanceUnitLabel, getElevationUnitLabel, getSpeedUnitLabel, UnitSystem } from "../utils/unitFormatting";

export function useUnitsViewModel(preferences = unitPreferencesService) {
  const [unitSystem, setUnitSystemState] = useState<UnitSystem>(() => preferences.read());
  const setUnitSystem = useCallback((nextUnitSystem: UnitSystem) => {
    setUnitSystemState(nextUnitSystem);
    preferences.write(nextUnitSystem);
  }, [preferences]);

  return useMemo(() => ({
    unitSystem,
    setUnitSystem,
    toggleUnitSystem: () => setUnitSystem(unitSystem === "metric" ? "imperial" : "metric"),
    distanceUnitLabel: getDistanceUnitLabel(unitSystem),
    speedUnitLabel: getSpeedUnitLabel(unitSystem),
    elevationUnitLabel: getElevationUnitLabel(unitSystem)
  }), [unitSystem, setUnitSystem]);
}
